import { useCallback } from "react";
import { generatePluralText } from "./useTeachings.js";
import { useBannerOrBlocker } from "../useBannerOrBlocker.js";
function useDurationText() {
    const { i18n: { durationUnit: durationUnitTexts, unknown } } = useBannerOrBlocker();
    return useCallback((duration, unit)=>typeof duration === "number" ? generatePluralText(duration, durationUnitTexts["n1"][unit], durationUnitTexts["nx"][unit]) : unknown, [
        durationUnitTexts,
        unknown
    ]);
}
export { useDurationText };
